<template>
  <div class="bg-white w-full p-4 sm:p-5">
    <input class="mb-4 w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-express" type="text" v-model="search" placeholder="Search Table">
    <div class="w-full overflow-x-auto">
      <table class="w-full text-sm">
        <thead>
        <tr class="border-b border-gray-200">
          <th class="px-3 py-3 text-left font-semibold text-expressgray whitespace-nowrap cursor-pointer hover:text-express" v-for="(column, index) in columns" :key="index"  @click="sortRecords(index)">
            {{column}}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr  v-for="(val , i) in rows" :key="i" class="border-b border-gray-100 hover:bg-gray-50">
          <td class="px-3 py-3 whitespace-nowrap">{{val[0]}}</td>
          <td class="px-3 py-3 whitespace-nowrap">{{val[1]}}</td>
          <td class="px-3 py-3 whitespace-nowrap">{{val[2]}}</td>
          <td class="px-3 py-3 whitespace-nowrap">{{val[3]}}</td>
          <td class="px-3 py-3 whitespace-nowrap">{{val[4]}}</td>
          <td class="px-3 py-3 whitespace-nowrap">
            <span
                class="px-2 py-1 rounded-full text-xs font-medium"
                :class="val[5] === 'Active' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-600'"
            >{{val[5]}}</span>
          </td>
          <td class="px-3 py-3 text-center">
            <label class="switch" v-if="user.primaryaccount === 'super_administrator'">
              <input type="checkbox" :checked="val[5]==='Active'"  @change="enable_disable(val[6],$event.target.checked)">
              <span class="slider round"></span>
            </label>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>


import {mapGetters} from "vuex";

export default {
  name:"RDEListTable",
  props: ['rowRaws'],
  created() {
   // console.log('RDEListTable ',this.user)
  },
  mounted() {
    this.rows =  [...this.rowRaws]
  },
  computed: {
    ...mapGetters({
     user: 'authentication/getUser'

    }),
  },
  data(){
    return {
      search:'',
      columns:[
        'Full-Name',	'Email'	, 'Mobile',	'Country'	,'Accout Type',	'Account Status', 'Enable/Disable Account'
      ],
      row:[],
      rows:[],
      sortIndex: null,
      sortDirection: null

    }
  },
  watch:{
    search: function (newvalue, oldvalue){
      // console.log(newvalue,oldvalue)
      this.onSearch()
    }
  },
  methods: {
    sortRecords: function (index){
      if(this.sortDirection  ==  null){
        this.sortDirection = 'asc'
      }
      this.sortIndex = index
      this.rows = this.rows.sort(
          (rowA,rowB)=> {
            if(typeof (rowA[index]) == 'number' || typeof (rowB[index]) == 'number' ){
              // console.log('number sortting')
              if(this.sortDirection === 'asc' || this.sortDirection == null){
                this.sortDirection = 'desc'
                return rowA[index] - rowB[index]
              }else{
                this.sortDirection = 'asc'
                return  rowB[index] - rowA[index]
              }
              // return rowA[index].localeCompare(rowB[index], undefined, {'numeric': true})
            }else{
              return rowA[index].localeCompare(rowB[index])
            }

          }
      )
    },
    onSearch: function (){
      let term = this.search
      let temp = this.rowRaws
      this.rows = temp.filter(
          row => row.join(" ").includes(term)
      )
    },
    enable_disable(user_id,status){
       console.log('enable_disable triggerred ' , `${JSON.stringify(user_id)} - ${status}`)
      this.$store.dispatch('admins/action_enable_disable_rde_account',{
        user_id: user_id,
        status: status,
        toast:this.$toast,
        router:this.$router
      });




    },
  }
}

</script>

<style scoped>
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
